const passRegEx = new RegExp('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$');   
const passwordValidator = {
    validate :(password)=> {
        return passRegEx.test(password) && !/\s/.test(password);
    }
}

export default passwordValidator;